import { WithStyles } from '@material-ui/core';
import Badge from '@material-ui/core/Badge';
import Button from '@material-ui/core/Button';
import Collapse from '@material-ui/core/Collapse';
import blueGrey from '@material-ui/core/colors/blueGrey';
import pink from '@material-ui/core/colors/pink';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Fab from '@material-ui/core/Fab';
import IconButton from '@material-ui/core/IconButton';
import List from '@material-ui/core/List';
import ListItem, { ListItemProps } from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText, {
	ListItemTextProps,
} from '@material-ui/core/ListItemText';
import { createStyles, withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import BookmarkIcon from '@material-ui/icons/Bookmark';
import DoneIcon from '@material-ui/icons/Done';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import GetAppIcon from '@material-ui/icons/GetApp';
import { push } from 'connected-react-router';
import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import i18n from '../resources/i18n';

import {
	ELearningKind,
	IIndexTreeItem,
	openELearningIndexTree,
	setELearningReservedTreeItem,
	setELearningTreeItem,
	setShowFirstTimeDialog,
	setShowTree,
	showELearningByBookmark,
} from '../actions/eLearning';
import ELExercise from '../icons/ELExercise';
import ELOutlineIcon from '../icons/ELOutlineIcon';
import ELQuestionnaire from '../icons/ELQuestionnaire';
import ELTestFormIcon from '../icons/ELTestFormIcon';
import ELTextIcon from '../icons/ELTextIcon';
import ELTitleIcon from '../icons/ELTitleIcon';
import { IRootState } from '../reducers';
import ScenarioFactory, {
	IFetchELearningProgressParam,
	IFetchELearningTreeParam,
	IStartELearningTextParam,
} from '../scenario/ELearningScenarioFactory';
import Config from '../site.config.json';
import { isMobile } from '../utils/MobileCheck';

const styles = (theme: Theme) =>
	createStyles({
		attached: {
			backgroundColor: theme.palette.secondary.light,
			padding: theme.spacing(1),
		},
		attachedName: {
			marginLeft: theme.spacing(1),
		},
		descriptionColor: {
			backgroundColor: 'rgba(0, 0, 0, 0.5)',
		},
		descriptionCss: {
			backgroundColor: pink[200],
			fontFamily: 'Helvetica, sans-serif',
			fontWeight: 'bold',
			height: '16px',
			left: '-19px',
			marginLeft: '12px',
			top: 10,
			width: '16px',
		},
		descriptionWidth: {
			width: '150px',
		},
		done: {
			color: blueGrey[500],
		},
		listChild: {
			paddingLeft: theme.spacing(4),
		},
		listRoot: {},
		required: {
			backgroundColor: pink[200],
			fontFamily: 'Helvetica, sans-serif',
			fontWeight: 'bold',
			height: '16px',
			right: 5,
			width: '16px',
		},
		timeBackgroundColor: {
			backgroundColor: 'rgba(62, 62, 64, 0.23)',
			borderBottom: '1px solid rgba(0, 0, 0, 0.5)',
			borderTop: '1px solid rgba(0, 0, 0, 0.5)',
			color: 'white',
		},
		timePadding: {
			paddingBottom: '0px',
			paddingTop: '0px',
		},
	});

interface IState {
	isClose: { [id: string]: boolean };
	reservingFromTest?: IIndexTreeItem;
	openNoticeGridQuestionnaire: boolean;
	openNoticeExercise: boolean;
	openNoticeExpired: { term: string; target: string } | null;
	showAlertMessage: boolean;
	testTitle: string[];
}

/**
 * 受講画面のインデックスツリーコンポーネント
 */
export class IndexTreeComponent extends React.Component<IProps, IState> {
	protected downloadForm: HTMLFormElement | null;

	constructor(props: IProps) {
		super(props);
		this.state = {
			isClose: {},
			openNoticeExercise: false,
			openNoticeExpired: null,
			openNoticeGridQuestionnaire: false,
			showAlertMessage: false,
			testTitle: [],
		};
	}

	/**
	 * Lifecycle Methods
	 */
	public componentDidUpdate(prevProps: IProps) {
		if (!prevProps.open && this.props.open) {
			// 閉じた状態から開いたらデータを再読み込み
			this.props.fetchELearningTree(this.props.token, {
				careerID: this.props.careerID,
				classID: this.props.classID,
				isPreview: this.props.preview,
				userAttr: this.props.userAttr,
			});
		}
		if (prevProps.reservedTreeItem && this.props.currentTreeItem) {
			if (
				prevProps.reservedTreeItem.id === this.props.currentTreeItem.id
			) {
				// テスト開始確認が終了したらクローズ
				this.props.closeIndexTree();
			}
		}
	}

	/**
	 * render
	 */
	public render() {
		const { open } = this.props;
		let beforeItem: IIndexTreeItem | undefined;
		let curentItem: IIndexTreeItem | undefined;
		let isFirst: boolean | undefined = true;
		const itemElements = (this.props.indexTree || [])
			.map(item => {
				if (
					item.answerPeriod &&
					item.answerPeriod.indexOf('～') !== -1
				) {
					item.answerPeriod = item.answerPeriod.replace(
						'～',
						i18n.t('～', {
							ns: 'force',
						})
					);
				}
				beforeItem = curentItem;
				curentItem = item;
				if (beforeItem) {
					isFirst = false;
				}
				return (
					<this.Item
						key={item.id}
						item={item}
						beforeItem={beforeItem}
						isFirst={isFirst}
					/>
				);
			})
			.filter(x => x);
		const listItemTextProps123: ListItemTextProps = {
			primary: i18n.t('IndexTree_0001'),
		};

		return (
			<>
				<SwipeableDrawer
					open={open}
					onOpen={this.handleOpenIndexTree}
					onClose={this.handleCloseIndexTree}
					// ライブラリ側で直接指定してしまっておりclass指定だと効かないので
					// 已むを得ず即値指定
					style={{ zIndex: 1200 }}
				>
					{this.attachedFile()}

					<List
						component="nav"
						disablePadding={true}
						className={this.props.classes.listRoot}
					>
						<ListItem>
							<ListItemText
								key={`0_text`}
								{...listItemTextProps123}
							/>
						</ListItem>
					</List>
					{itemElements}
					<this.Description />
				</SwipeableDrawer>

				<Dialog
					open={this.state.reservingFromTest ? true : false}
					onClose={this.handleCloseTerminateTest}
				>
					<DialogTitle id="alert-test">
						{i18n.t('IndexTree_0002')}
					</DialogTitle>
					<DialogContent>
						<DialogContentText id="alert-test">
							{i18n.t('IndexTree_0003')}
							<br />
							{i18n.t('IndexTree_0036')}
						</DialogContentText>
					</DialogContent>
					<DialogActions>
						<Button
							onClick={this.handleTerminateTest}
							color="primary"
						>
							{i18n.t('IndexTree_0004')}
						</Button>
						<Button onClick={this.handleCloseTerminateTest}>
							{i18n.t('IndexTree_0005')}
						</Button>
					</DialogActions>
				</Dialog>

				<Dialog
					open={this.state.openNoticeGridQuestionnaire}
					onClose={this.handleCloseNoticeGridQuestionnaire}
				>
					<DialogTitle>{i18n.t('IndexTree_0006')}</DialogTitle>
					<DialogContent>
						<DialogContentText>
							{i18n.t('IndexTree_0007')}
						</DialogContentText>
					</DialogContent>
					<DialogActions>
						<Button
							onClick={this.handleCloseNoticeGridQuestionnaire}
							color="primary"
						>
							{i18n.t('IndexTree_0008')}
						</Button>
					</DialogActions>
				</Dialog>

				<Dialog
					open={this.state.openNoticeExercise}
					onClose={this.handleCloseNoticeExercise}
				>
					<DialogTitle>{i18n.t('IndexTree_0009')}</DialogTitle>
					<DialogContent>
						<DialogContentText>
							{i18n.t('IndexTree_0010')}
						</DialogContentText>
					</DialogContent>
					<DialogActions>
						<Button
							onClick={this.handleCloseNoticeExercise}
							color="primary"
						>
							{i18n.t('IndexTree_0011')}
						</Button>
					</DialogActions>
				</Dialog>

				{this.state.openNoticeExpired && (
					<Dialog open={true} onClose={this.handleCloseNoticeExpired}>
						<DialogTitle>{i18n.t('IndexTree_0012')}</DialogTitle>
						<DialogContent>
							<DialogContentText>
								{i18n.t('IndexTree_0013', {
									term: this.state.openNoticeExpired.term,
									// tslint:disable-next-line:object-literal-sort-keys
									target: this.state.openNoticeExpired.target,
								})}
							</DialogContentText>
						</DialogContent>
						<DialogActions>
							<Button
								onClick={this.handleCloseNoticeExpired}
								color="primary"
							>
								{i18n.t('IndexTree_0014')}
							</Button>
						</DialogActions>
					</Dialog>
				)}

				<Dialog
					open={this.state.showAlertMessage}
					onClose={this.handleCloseShowAlertMessage}
				>
					<DialogTitle>{i18n.t('IndexTree_0015')}</DialogTitle>
					<DialogContent>
						<DialogContentText>
							{this.state.testTitle.map((msg: string, i) => (
								<React.Fragment key={i}>
									<span
										key={`span-${i}`}
										dangerouslySetInnerHTML={{
											__html: msg,
										}}
									/>
									<br key={`br-${i}`} />
								</React.Fragment>
							))}
						</DialogContentText>
					</DialogContent>
					<DialogActions>
						<Button
							onClick={this.handleCloseShowAlertMessage}
							color="primary"
						>
							{i18n.t('IndexTree_0016')}
						</Button>
					</DialogActions>
				</Dialog>

				<Dialog
					open={open && this.props.isFirst === 1}
					onClose={this.closeDialog}
					aria-labelledby="simple-dialog-title"
				>
					<DialogTitle>{i18n.t('IndexTree_0017')}</DialogTitle>
					<DialogContent>
						<DialogContentText id="alert-dialog-slide-description">
							{i18n.t('IndexTree_0018')}
						</DialogContentText>
					</DialogContent>
					<DialogActions>
						<Button onClick={this.closeDialog} color="primary">
							{i18n.t('IndexTree_0019')}
						</Button>
					</DialogActions>
				</Dialog>
			</>
		);
	}

	/**
	 * 添付ファイルコンポーネント
	 */
	protected attachedFile() {
		if (!this.props.documentName || isMobile()) {
			return;
		}

		const { documentName, classes } = this.props;
		const url =
			Config.tsqPath + '/tsq/pkg/action/el/documentDownload.action';
		const searchCondition = JSON.stringify({
			careerID: this.props.careerID,
			lang: this.props.userAttr.lang,
		});

		return (
			<>
				<div className={classes.attached}>
					<Fab
						color="primary"
						aria-label="Download"
						onClick={this.handleDownload}
					>
						<GetAppIcon />
					</Fab>
					<span className={classes.attachedName}>{documentName}</span>
					<form
						method="POST"
						action={url}
						ref={form => (this.downloadForm = form)}
						target="_blank"
					>
						<input
							type="hidden"
							name="searchCondition"
							value={searchCondition}
						/>
						<input
							type="hidden"
							name="__tsqCookieName"
							value="TSQ_FD_0"
						/>
						<input
							type="hidden"
							name="__tsqFileType"
							value="documentFile"
						/>
					</form>
				</div>
			</>
		);
	}

	protected Description: React.FC = props => {
		return (
			<List component="nav" disablePadding={true}>
				<ListItem
					className={this.props.classes.timePadding}
					style={{ marginTop: '50px' }}
				>
					<ListItemIcon
						className={this.props.classes.descriptionWidth}
					>
						<Badge
							color="error"
							badgeContent="!"
							classes={{
								badge: this.props.classes.descriptionCss,
							}}
						>
							<span style={{ marginLeft: '22px' }}>
								{i18n.t('IndexTree_0020')}
							</span>
						</Badge>
					</ListItemIcon>
				</ListItem>
				<ListItem
					className={this.props.classes.timePadding}
					style={{ marginTop: '20px' }}
				>
					<ListItemIcon
						className={this.props.classes.descriptionWidth}
					>
						<>
							<ELTextIcon />
							<span
								style={{ marginLeft: '10px', marginTop: '3px' }}
							>
								{i18n.t('IndexTree_0021')}
							</span>
						</>
					</ListItemIcon>
					<ListItemIcon
						className={this.props.classes.descriptionWidth}
					>
						<>
							<ELTestFormIcon />
							<span
								style={{ marginLeft: '10px', marginTop: '3px' }}
							>
								{i18n.t('IndexTree_0022')}
							</span>
						</>
					</ListItemIcon>
				</ListItem>
				<ListItem
					className={this.props.classes.timePadding}
					style={{ marginBottom: '50px' }}
				>
					<ListItemIcon
						className={this.props.classes.descriptionWidth}
					>
						<>
							<ELQuestionnaire />
							<span
								style={{ marginLeft: '10px', marginTop: '3px' }}
							>
								{i18n.t('IndexTree_0023')}
							</span>
						</>
					</ListItemIcon>
					<ListItemIcon
						className={this.props.classes.descriptionWidth}
					>
						<>
							<ELExercise />
							<span
								style={{ marginLeft: '10px', marginTop: '3px' }}
							>
								{i18n.t('IndexTree_0024')}
							</span>
						</>
					</ListItemIcon>
				</ListItem>
			</List>
		);
	};

	protected listItemTextPropsForSubject = (item: IIndexTreeItem) => {
		if (item.subjectText === '1') {
			return item.text + ' ' + i18n.t('INDEXTREE_YES');
		} else if (item.subjectText === '2') {
			return item.text + ' ' + i18n.t('INDEXTREE_UNDEFINED');
		} else if (item.subjectText === '0') {
			return item.text + ' ' + i18n.t('INDEXTREE_N0');
		} else {
			return item.text;
		}
	};

	/**
	 * ツリーアイテム作成
	 * @param item 対象アイテム
	 */
	protected Item: React.FC<{
		item: IIndexTreeItem;
		isChild?: boolean;
		beforeItem?: IIndexTreeItem;
		isFirst?: boolean;
	}> = props => {
		const { item, beforeItem, isFirst } = props;
		if (!this.isDisplay(item)) {
			return <></>;
		}

		const listItemProps: ListItemProps = {};
		let itemElements: JSX.Element[] = [];
		let iconElement: JSX.Element | null = null;
		const listItemTextProps: ListItemTextProps = {
			primary: i18n.t(item.text, { ns: 'force' }),
		};
		let groupTime: JSX.Element | null = null;
		const groupTimeProps: ListItemTextProps = {
			primary: item.answerPeriod,
		};
		if (beforeItem || isFirst) {
			groupTime = (
				<List
					component="nav"
					disablePadding={true}
					className={this.props.classes.timeBackgroundColor}
				>
					<ListItem className={this.props.classes.timePadding}>
						<ListItemText
							key={`${item.id}_text_time`}
							{...groupTimeProps}
						/>
					</ListItem>
				</List>
			);
		}

		// 現在表示中か？
		let isCurrent = false;
		const { currentTreeItem } = this.props;
		if (currentTreeItem) {
			if (item.id === currentTreeItem.id) {
				isCurrent = true;
			} else if (
				item.kind === ELearningKind.TEST &&
				item.children &&
				currentTreeItem.kind === ELearningKind.TESTLOG
			) {
				// テストの場合はテスト履歴を対象とする
				for (const child of item.children) {
					if (child.id === currentTreeItem.id) {
						isCurrent = true;
						break;
					}
				}
			}
		}
		if (isCurrent) {
			listItemTextProps.primaryTypographyProps = {
				color: 'primary',
			};
		}

		switch (item.kind) {
			case ELearningKind.OUTLINE:
				if (!item.disableFlg) {
					listItemProps.button = true;
					listItemProps.onClick = this.handleClickItem(item);
				}
				if (item.expired) {
					listItemProps.onClick = this.handleClickItem(item);
				}
				iconElement = (
					<ListItemIcon>
						<ELOutlineIcon />
					</ListItemIcon>
				);
				itemElements = [
					<ListItemText
						key={`${item.id}_text`}
						{...listItemTextProps}
					/>,
				];
				break;
			case ELearningKind.TITLE:
			case ELearningKind.SCORM_TITLE:
				iconElement = (
					<ListItemIcon>
						<ELTitleIcon />
					</ListItemIcon>
				);
				itemElements = [
					<ListItemText
						key={`${item.id}_text`}
						{...listItemTextProps}
					/>,
				];
				break;
			case ELearningKind.TEXT:
				listItemProps.button = true;
				listItemProps.onClick = this.handleClickItem(item);

				if (item.expired) {
					listItemProps.onClick = this.handleClickItem(item);
				}
				iconElement = (
					<ListItemIcon>
						<ELTextIcon />
					</ListItemIcon>
				);
				itemElements = [
					...(item.userBookMark !== 0
						? [
								<IconButton
									key={`${item.id}_bookmark`}
									onClick={this.handleClickBookmark(item)}
								>
									<BookmarkIcon />
								</IconButton>,
						  ]
						: []),
					...[
						<ListItemText
							key={`${item.id}_text`}
							{...listItemTextProps}
						/>,
					],
				];
				break;
			case ELearningKind.TEST:
				listItemProps.button = true;
				listItemProps.onClick = this.handleClickItem(item);

				if (item.expired) {
					listItemProps.onClick = this.handleClickItem(item);
				}
				iconElement = (
					<ListItemIcon>
						<ELTestFormIcon />
					</ListItemIcon>
				);
				itemElements = [
					<ListItemText
						key={`${item.id}_text`}
						{...listItemTextProps}
					/>,
				];
				break;
			case ELearningKind.TESTLOG:
				if (!item.disableFlg) {
					listItemProps.button = true;
					listItemProps.onClick = this.handleClickItem(item);
				}
				itemElements = [
					<ListItemText
						key={`${item.id}_text`}
						{...listItemTextProps}
					/>,
				];
				break;
			case ELearningKind.ENQUETE:
				if (!item.disableFlg) {
					if (!item.expired) {
						listItemProps.button = true;
					}
					listItemProps.onClick = this.handleClickItem(item);
				}
				iconElement = (
					<ListItemIcon>
						<ELQuestionnaire />
					</ListItemIcon>
				);
				// listItemTextProps.secondary = item.answerPeriod;

				itemElements = [
					<ListItemText
						key={`${item.id}_text`}
						{...listItemTextProps}
					/>,
				];
				break;
			case ELearningKind.SUBJECT:
				if (!item.disableFlg) {
					if (!item.expired) {
						listItemProps.button = true;
					}
					listItemProps.onClick = this.handleClickItem(item);
				}
				iconElement = (
					<ListItemIcon>
						<ELExercise />
					</ListItemIcon>
				);
				// listItemTextProps.secondary = item.answerPeriod;

				itemElements = [
					<ListItemText
						key={`${item.id}_text`}
						primary={this.listItemTextPropsForSubject(item)}
					/>,
				];
				break;
			case ELearningKind.SCORM:
				if (!item.disableFlg) {
					listItemProps.button = true;
					listItemProps.onClick = this.handleClickItem(item);
				}
				if (item.expired) {
					listItemProps.onClick = this.handleClickItem(item);
				}
				iconElement = (
					<ListItemIcon>
						<ELTextIcon />
					</ListItemIcon>
				);
				itemElements = [
					...(item.userBookMark !== 0
						? [
								<IconButton
									key={`${item.id}_bookmark`}
									onClick={this.handleClickBookmark(item)}
								>
									<BookmarkIcon />
								</IconButton>,
						  ]
						: []),
					...[
						<ListItemText
							key={`${item.id}_text`}
							{...listItemTextProps}
						/>,
					],
				];
				break;
		}

		if (iconElement && item.requiredFlg) {
			iconElement = (
				<Badge
					color="error"
					badgeContent="!"
					classes={{ badge: this.props.classes.required }}
				>
					{iconElement}
				</Badge>
			);
		}

		let isExpand = false;
		if (item.children) {
			for (const child of item.children) {
				if (this.isDisplay(child)) {
					isExpand = true;
					break;
				}
			}
		}

		if (item.iconClass && item.iconClass.search(/\-complete/) > -1) {
			itemElements.unshift(
				<DoneIcon className={this.props.classes.done} />
			);
		}
		if (beforeItem && groupTime) {
			const beforeStartTime: string[] = beforeItem.answerPeriod.split(
				'～'
			);
			const newStartTime: string[] = item.answerPeriod.split('～');
			if (beforeStartTime[0].trim() === newStartTime[0].trim()) {
				groupTime = null;
			}
		}
		let tabStyle: string = '';

		if (!props.isChild && item.expired) {
			tabStyle = this.props.classes.descriptionColor;
		}
		if (!props.isChild && !item.expired) {
			tabStyle = this.props.classes.listRoot;
		}
		if (props.isChild) {
			tabStyle = this.props.classes.listChild;
		}

		return (
			<>
				{this.props.windowId !== '1' && groupTime}
				<List
					component="nav"
					disablePadding={true}
					className={tabStyle}
				>
					<ListItem button={true} {...listItemProps as any}>
						{iconElement}
						{itemElements}
						{isExpand && (
							<ListItemSecondaryAction>
								<IconButton
									onClick={this.handleExpand(item.id)}
								>
									{this.state.isClose[item.id] ? (
										<ExpandMore />
									) : (
										<ExpandLess />
									)}
								</IconButton>
							</ListItemSecondaryAction>
						)}
					</ListItem>
					{item.children && (
						<Collapse
							in={!this.state.isClose[item.id]}
							timeout="auto"
							unmountOnExit={true}
						>
							{item.children
								.filter(c => this.isDisplay(c))
								.map(child => (
									<this.Item
										key={child.id}
										item={child}
										isChild={true}
									/>
								))}
						</Collapse>
					)}
				</List>
			</>
		);
	};

	/**
	 * 表示要否判定
	 * @param item 判定対象アイテム
	 */
	protected isDisplay(item: IIndexTreeItem) {
		if (
			item.kind === ELearningKind.OUTLINE ||
			item.kind === ELearningKind.TITLE ||
			item.kind === ELearningKind.TEXT ||
			item.kind === ELearningKind.TEST ||
			item.kind === ELearningKind.ENQUETE ||
			item.kind === ELearningKind.SUBJECT ||
			item.kind === ELearningKind.SCORM_TITLE ||
			item.kind === ELearningKind.SCORM
		) {
			return true;
		}
		return false;
	}

	/**
	 * インデックスオープンハンドラ
	 */
	protected handleOpenIndexTree = () => {
		this.props.openIndexTree();
	};

	/**
	 * インデックスクローズハンドラ
	 */
	protected handleCloseIndexTree = () => {
		this.props.closeIndexTree();
	};

	/**
	 * ブックマーククリックハンドラ
	 */
	protected handleClickBookmark = (item: IIndexTreeItem) => (
		event: React.MouseEvent<HTMLElement>
	) => {
		this.props.closeIndexTree();
		this.props.showELearningByBookmark(item.id, item.userBookMark);
		event.stopPropagation();
	};

	protected closeDialog = () => {
		this.props.setShowFirstTimeDialog(2);
	};

	/**
	 * ツリーアイテムクリックハンドラ
	 */
	protected handleClickItem = (item: IIndexTreeItem) => async () => {
		if (item.kind !== ELearningKind.TEST) {
			this.props.setShowFirstTimeDialog(3);
		}
		if (item.expired) {
			// 期限切れ
			let term: string;
			let target: string;
			switch (item.kind) {
				case ELearningKind.OUTLINE:
					term = i18n.t('IndexTree_0025');
					target = i18n.t('IndexTree_0026');
					break;
				case ELearningKind.TEST:
					term = i18n.t('IndexTree_0027');
					target = i18n.t('IndexTree_0028');
					break;
				case ELearningKind.ENQUETE:
					term = i18n.t('IndexTree_0029');
					target = i18n.t('IndexTree_0030');
					break;
				case ELearningKind.SUBJECT:
					term = i18n.t('IndexTree_0031');
					target = i18n.t('IndexTree_0032');
					break;
				default:
					term = i18n.t('IndexTree_0033');
					target = i18n.t('IndexTree_0034');
			}
			this.setState({ openNoticeExpired: { term, target } });
			return;
		}

		const prev = this.props.currentTreeItem as IIndexTreeItem;
		if (
			item.kind === ELearningKind.TEXT &&
			!this.props.preview &&
			this.props.admintFlg === '1' &&
			prev
		) {
			// Admint動画修了判定
			await this.props.fetchAdmintCompleteModel(this.props.token, {
				careerID: this.props.careerID,
				classID: this.props.classID,
				isMenu: true,
				isPreview: this.props.preview,
				page: this.props.currentPage,
				pageCount: prev.pageCount,
				topicID: prev.id,
				userAttr: this.props.userAttr,
			});
		}

		if (
			(item.kind === ELearningKind.TEST ||
				item.kind === ELearningKind.TEXT) &&
			this.props.mapParam.orderFlg === 1 &&
			!(item.iconClass && item.iconClass.search(/\-complete/) > -1) &&
			item.requiredFlg &&
			!this.props.preview
		) {
			const messages: string[] = [];
			this.selectMustLearn(this.props.indexTree, item, messages);
			if (messages.length > 0) {
				this.setState({
					showAlertMessage: true,
					testTitle: messages,
				});
				return;
			}
		}

		if (
			this.props.currentTreeItem &&
			(this.props.currentTreeItem.kind === ELearningKind.TEST ||
				this.props.currentTreeItem.kind === ELearningKind.ENQUETE)
		) {
			// テスト実施中
			this.setState({ reservingFromTest: item });
			return;
		}

		this.moveItem(item);
	};

	/**
	 * 項目移動
	 * @param item 移動先項目
	 */
	protected moveItem(item: IIndexTreeItem) {
		this.props.fetchELearningProgress(this.props.token, {
			careerID: this.props.careerID,
			classID: this.props.classID,
			isPreview: this.props.preview,
			userId: this.props.userAttr.userId,
		});
		switch (item.kind) {
			case ELearningKind.OUTLINE:
			case ELearningKind.TEXT:
			case ELearningKind.TESTLOG:
			case ELearningKind.SCORM:
				this.props.closeIndexTree();
				this.props.setELearningTreeItem(item);
				break;
			case ELearningKind.ENQUETE:
				if (isMobile() && item.enqueteType === '2') {
					this.setState({ openNoticeGridQuestionnaire: true });
					break;
				}
				this.props.closeIndexTree();
				this.props.setELearningTreeItem(item);
				break;
			case ELearningKind.SUBJECT:
				if (isMobile()) {
					this.setState({ openNoticeExercise: true });
					break;
				}
				this.props.closeIndexTree();
				this.props.setELearningTreeItem(item);
				break;
			case ELearningKind.TEST:
				this.props.setShowTree(false);
				this.props.setELearningReservedTreeItem(item);
				break;
		}
	}

	protected selectMustLearn(
		indexTree: IIndexTreeItem[],
		param: IIndexTreeItem,
		messages: string[]
	): boolean {
		let flg: boolean = false;

		for (const item of indexTree) {
			if (messages.length > 0 || item.id === param.id) {
				flg = true;
				break;
			}
			if (item.kind !== 1 && item.kind !== 2 && item.kind !== 3) {
				continue;
			}

			if (
				item.children &&
				item.children.length > 0 &&
				item.children[0].kind === 6 &&
				!(item.iconClass && item.iconClass.search(/\-complete/) > -1) &&
				item.requiredFlg &&
				this.props.mapParam.markTimingFlg === 1
			) {
				if (this.findTestResult(item.children)) {
					continue;
				}
			}

			if (
				!(item.iconClass && item.iconClass.search(/\-complete/) > -1) &&
				item.requiredFlg
			) {
				messages.push(
					i18n.t('IndexTree_0035', {
						item: i18n.t(item.text, { ns: 'force' }),
					})
				);
				continue;
			}

			if (item.children) {
				flg = this.selectMustLearn(item.children, param, messages);
				if (flg) {
					break;
				}
			}
		}
		return flg;
	}

	protected findTestResult(indexTree: IIndexTreeItem[]): boolean {
		for (const item of indexTree) {
			if (!item.disableFlg) {
				return true;
			}
		}
		return false;
	}

	/**
	 * 要素展開ハンドラ
	 */
	protected handleExpand = (id: string) => () => {
		if (!this.state.isClose) {
			return;
		}
		this.state.isClose[id] = !this.state.isClose[id];
		this.setState({ isClose: this.state.isClose });
	};

	/**
	 * 添付ファイルダウンロード
	 */
	protected handleDownload = () => {
		if (this.downloadForm) {
			this.downloadForm.submit();
		}
	};

	/**
	 * テスト中断ハンドラ
	 */
	protected handleTerminateTest = () => {
		this.moveItem(this.state.reservingFromTest as IIndexTreeItem);
		this.setState({ reservingFromTest: undefined });
	};

	/**
	 * テスト中断確認クローズハンドラ
	 */
	protected handleCloseTerminateTest = () => {
		this.setState({ reservingFromTest: undefined });
	};

	/**
	 * アンケート警告クローズハンドラ
	 */
	protected handleCloseNoticeGridQuestionnaire = () => {
		this.setState({ openNoticeGridQuestionnaire: false });
	};

	/**
	 * 課題警告クローズハンドラ
	 */
	protected handleCloseNoticeExercise = () => {
		this.setState({ openNoticeExercise: false });
	};

	/**
	 * 期限切れ警告クローズハンドラ
	 */
	protected handleCloseNoticeExpired = () => {
		this.setState({ openNoticeExpired: null });
	};

	protected handleCloseShowAlertMessage = () => {
		this.setState({ showAlertMessage: false, testTitle: [] });
	};
}

const mapStateToProps = (state: IRootState) => ({
	admintFlg: state.eLearning.admintFlg,
	currentPage: state.eLearning.currentPage,
	currentTreeItem: state.eLearning.currentTreeItem,
	documentName: state.eLearning.documentName,
	indexTree: state.eLearning.indexTree,
	isFirst: state.eLearning.isFirst,
	open: state.eLearning.isOpenIndexTree,
	reservedTreeItem: state.eLearning.reservedTreeItem,

	token: state.session.token,
	userAttr: state.session.userAttr,

	mapParam: state.eLearning.mapParam,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	closeIndexTree: () => dispatch(openELearningIndexTree({ isOpen: false })),
	fetchAdmintCompleteModel: (
		token: string,
		arg: IStartELearningTextParam
	) => {
		const s = ScenarioFactory.createAdmintCompleteModel(dispatch, token);
		return s.run(arg);
	},
	fetchELearningProgress: (
		token: string,
		arg: IFetchELearningProgressParam
	) => {
		const s = ScenarioFactory.createFetchELearningProgress(dispatch, token);
		s.run(arg);
	},
	fetchELearningTree: (token: string, arg: IFetchELearningTreeParam) => {
		const s = ScenarioFactory.createFetchELearningTree(dispatch, token);
		s.run(arg);
	},
	openIndexTree: () => dispatch(openELearningIndexTree({ isOpen: true })),
	pushHistory: (to: string) => dispatch(push(to)),
	setELearningReservedTreeItem: (item: IIndexTreeItem) =>
		dispatch(setELearningReservedTreeItem({ item })),
	setELearningTreeItem: (item: IIndexTreeItem) =>
		dispatch(setELearningTreeItem({ item })),
	showELearningByBookmark: (topicID: string, page: number) =>
		dispatch(showELearningByBookmark({ topicID, page })),

	setShowFirstTimeDialog: (isFirst: number) =>
		dispatch(setShowFirstTimeDialog({ isFirst })),

	setShowTree: (showTree: boolean) => dispatch(setShowTree({ showTree })),
});

export interface IIndexTreeProps {
	careerID: string;
	classID: string;
	preview: boolean;
	windowId?: string;
}

const mergeProps = (
	state: IStateProps,
	events: IDispatchProps,
	ownProps: IOwnProps
) => ({
	...state,
	...events,
	...ownProps,
});

type IStateProps = ReturnType<typeof mapStateToProps>;
type IDispatchProps = ReturnType<typeof mapDispatchToProps>;
type IOwnProps = WithStyles<typeof styles> & IIndexTreeProps;
type IProps = ReturnType<typeof mergeProps>;

const Connected = connect(
	mapStateToProps,
	mapDispatchToProps,
	mergeProps
)(IndexTreeComponent);

const IndexTree = withStyles(styles)(Connected);

export default IndexTree;



// WEBPACK FOOTER //
// ./src/containers/IndexTree.tsx